import React, { useContext, useEffect, useRef, useState } from "react";

import { useParams, useHistory } from "react-router-dom";

import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import ChatList from "./ChatList";
import ChatMessages from "./ChatMessages";
import { UsersFilter } from "../../components/UsersFilter";
import MainHeader from "../../components/MainHeader";
import api from "../../services/api";
// import { SocketContext } from "../../context/Socket/SocketContext";

import { has, isObject } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    padding: theme.spacing(2),
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  hero: {
    flexShrink: 0, borderRadius: 16, padding: theme.spacing(1.5, 2.5),
    marginBottom: theme.spacing(1.5),
    background: theme.palette.type === "dark"
      ? "linear-gradient(135deg, #0A1628 0%, #0D1F3C 100%)"
      : "linear-gradient(135deg, #EBF3FF 0%, #D6E9FF 100%)",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(0,140,255,0.18)" : "1px solid rgba(0,102,255,0.12)",
    boxShadow: "0 4px 16px rgba(0,102,255,0.07)",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    gap: theme.spacing(2), position: "relative", overflow: "hidden",
  },
  heroBgCircle: {
    position: "absolute", right: -20, top: -20, width: 140, height: 140,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle, rgba(0,102,255,0.07) 0%, transparent 70%)",
  },
  heroLeft: { display: "flex", alignItems: "center", gap: theme.spacing(1.5), zIndex: 1 },
  heroIcon: {
    width: 48, height: 48, borderRadius: 14, flexShrink: 0, fontSize: "1.3rem",
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 6px 16px rgba(0,102,255,0.3)",
  },
  heroTitle: {
    fontWeight: 800, fontSize: "1.1rem", letterSpacing: "-0.3px",
    color: theme.palette.type === "dark" ? "#ffffff" : "#0A1628",
  },
  heroSubtitle: {
    fontSize: "0.75rem", marginTop: 2,
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.5)" : "rgba(10,22,40,0.55)",
  },
  heroRight: { display: "flex", alignItems: "center", gap: theme.spacing(1.5), zIndex: 1 },
  heroChip: {
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.9)",
    border: "1px solid rgba(0,102,255,0.15)", borderRadius: 10,
    fontWeight: 700, fontSize: "0.72rem",
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.7)" : "#0A1628",
  },
  contentShell: {
    flex: 1,
    overflow: "hidden",
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17, 24, 39, 0.09)",
  },
  gridContainer: {
    flex: 1,
    height: "100%",
    background: theme.palette.background.paper,
  },
  gridItem: {
    height: "100%",
  },
  gridItemTab: {
    height: "92%",
    width: "100%",
  },
  btnContainer: {
    textAlign: "right",
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.02)"
        : "rgba(15, 23, 42, 0.02)",
  },
  actionButton: {
    minHeight: 38,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: "0.74rem",
    padding: theme.spacing(0.6, 1.2),
    boxShadow: "0 6px 14px rgba(7, 64, 171, 0.14)",
  },
  tabsRoot: {
    minHeight: 40,
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& .MuiTab-root": {
      minHeight: 40,
      fontSize: "0.78rem",
      fontWeight: 600,
      textTransform: "none",
    },
  },
}));

export function ChatModal({
  open,
  chat,
  type,
  handleClose,
  handleLoadNewChat,
}) {
  const [users, setUsers] = useState([]);
  const [title, setTitle] = useState("");

  useEffect(() => {
    setTitle("");
    setUsers([]);
    if (type === "edit") {
      const userList = chat.users.map((u) => ({
        id: u.user.id,
        name: u.user.name,
      }));
      setUsers(userList);
      setTitle(chat.title);
    }
  }, [chat, open, type]);

  const handleSave = async () => {
    try {
      if (type === "edit") {
        await api.put(`/chats/${chat.id}`, {
          users,
          title,
        });
      } else {
        const { data } = await api.post("/chats", {
          users,
          title,
        });
        handleLoadNewChat(data);
      }
      handleClose();
    } catch (err) { }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{i18n.t("chatInternal.modal.title")}</DialogTitle>
      <DialogContent>
        <Grid spacing={2} container>
          <Grid xs={12} style={{ padding: 18 }} item>
            <TextField
              label="Título"
              placeholder="Título"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
            />
          </Grid>
          <Grid xs={12} item>
            <UsersFilter
              onFiltered={(users) => setUsers(users)}
              initialUsers={users}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {i18n.t("chatInternal.modal.cancel")}
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={users === undefined || users.length === 0 || title === null || title === "" || title === undefined}
        >
          {i18n.t("chatInternal.modal.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Chat(props) {
  const classes = useStyles();
  const { user, socket } = useContext(AuthContext);
  const history = useHistory();

  const [showDialog, setShowDialog] = useState(false);
  const [dialogType, setDialogType] = useState("new");
  const [currentChat, setCurrentChat] = useState({});
  const [chats, setChats] = useState([]);
  const [chatsPageInfo, setChatsPageInfo] = useState({ hasMore: false });
  const [messages, setMessages] = useState([]);
  const [messagesPageInfo, setMessagesPageInfo] = useState({ hasMore: false });
  const [messagesPage, setMessagesPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const isMounted = useRef(true);
  const scrollToBottomRef = useRef();
  const { id } = useParams();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      findChats().then((data) => {
        const { records } = data;
        if (records.length > 0) {
          setChats(records);
          setChatsPageInfo(data);

          if (id && records.length) {
            const chat = records.find((r) => r.uuid === id);
            selectChat(chat);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isObject(currentChat) && has(currentChat, "id")) {
      findMessages(currentChat.id).then(() => {
        if (typeof scrollToBottomRef.current === "function") {
          setTimeout(() => {
            scrollToBottomRef.current();
          }, 300);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChat]);

  useEffect(() => {
    const companyId = user.companyId;
    // const socket = socketConnection({ companyId, userId: user.id });

    const onChatUser = (data) => {

      console.log(data)
      if (data.action === "create") {
        setChats((prev) => [data.record, ...prev]);
      }
      if (data.action === "update") {
        const changedChats = chats.map((chat) => {
          if (chat.id === data.record.id) {
            setCurrentChat(data.record);
            return {
              ...data.record,
            };
          }
          return chat;
        });
        setChats(changedChats);
      }
    }
    /*
     * KORAX INTERNAL CHAT ACTIVITY V2
     *
     * Toda mensagem nova promove a conversa
     * para o topo da lista, igual ao WhatsApp.
     */
    const promoteChat = incomingChat => {

      if (!incomingChat?.id) {
        return;
      }

      const userIsMember =
        Array.isArray(incomingChat.users) &&
        incomingChat.users.some(
          item =>
            Number(item.userId) ===
            Number(user.id)
        );

      /*
       * O socket da empresa recebe eventos de todos.
       * Somente participantes podem receber o chat
       * dentro da propria lista.
       */
      if (!userIsMember) {
        return;
      }

      setChats(prev => [
        incomingChat,
        ...prev.filter(
          chat =>
            Number(chat.id) !==
            Number(incomingChat.id)
        )
      ]);
    };


    const updateChatWithoutMoving =
      incomingChat => {

        if (!incomingChat?.id) {
          return;
        }

        setChats(prev =>
          prev.map(chat =>
            Number(chat.id) ===
            Number(incomingChat.id)
              ? {
                  ...incomingChat
                }
              : chat
          )
        );
      };


    const onChat = data => {

      if (
        data.action === "new-message" &&
        data.chat
      ) {

        promoteChat(
          data.chat
        );
      }


      if (
        data.action === "update" &&
        data.chat
      ) {

        updateChatWithoutMoving(
          data.chat
        );
      }


      if (
        data.action === "delete"
      ) {

        setChats(prev =>
          prev.filter(
            chat =>
              Number(chat.id) !==
              Number(data.id)
          )
        );

        /*
         * Mantemos o comportamento atual
         * somente quando a conversa removida
         * for exatamente a conversa aberta.
         */
        if (
          Number(currentChat?.id) ===
          Number(data.id)
        ) {

          setMessages([]);
          setMessagesPage(1);

          setMessagesPageInfo({
            hasMore: false
          });

          setCurrentChat({});

          history.push(
            "/chats"
          );
        }
      }
    };


    const onCurrentChat = data => {

      if (
        data.action === "new-message"
      ) {

        /*
         * Evita inserir duas vezes a mesma mensagem
         * caso algum evento seja repetido.
         */
        setMessages(prev => {

          const alreadyExists =
            prev.some(
              item =>
                Number(item.id) ===
                Number(data.newMessage?.id)
            );

          if (alreadyExists) {
            return prev;
          }

          return [
            ...prev,
            data.newMessage
          ];
        });


        if (data.chat) {

          promoteChat(
            data.chat
          );
        }


        if (
          typeof scrollToBottomRef.current ===
          "function"
        ) {

          scrollToBottomRef.current();
        }
      }


      if (
        data.action === "update" &&
        data.chat
      ) {

        updateChatWithoutMoving(
          data.chat
        );


        if (
          typeof scrollToBottomRef.current ===
          "function"
        ) {

          scrollToBottomRef.current();
        }
      }
    };


    socket.on(`company-${companyId}-chat-user-${user.id}`, onChatUser);
    socket.on(`company-${companyId}-chat`, onChat);
    if (isObject(currentChat) && has(currentChat, "id")) {
      socket.on(`company-${companyId}-chat-${currentChat.id}`, onCurrentChat);
    }

    return () => {
      socket.off(`company-${companyId}-chat-user-${user.id}`, onChatUser);
      socket.off(`company-${companyId}-chat`, onChat);
      if (isObject(currentChat) && has(currentChat, "id")) {
        socket.off(`company-${companyId}-chat-${currentChat.id}`, onCurrentChat);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChat]);

  const selectChat = (chat) => {
    try {
      setMessages([]);
      setMessagesPage(1);
      setCurrentChat(chat);
      setTab(1);
    } catch (err) { }
  };

  const sendMessage = async (
    contentMessage,
    file = null,
    replyToMessageId = null
  ) => {
    setLoading(true);

    try {
      if (file) {
        const formData = new FormData();

        formData.append(
          "message",
          contentMessage || ""
        );

        formData.append(
          "file",
          file
        );

        if (replyToMessageId) {
          formData.append(
            "replyToMessageId",
            String(replyToMessageId)
          );
        }

        await api.post(
          `/chats/${currentChat.id}/messages`,
          formData
        );
      } else {
        await api.post(
          `/chats/${currentChat.id}/messages`,
          {
            message: contentMessage,
            replyToMessageId
          }
        );
      }
    } catch (err) {
      console.error(
        "Erro ao enviar mensagem interna:",
        err
      );
    }

    setLoading(false);
  };

  const deleteChat = async (chat) => {
    try {
      await api.delete(`/chats/${chat.id}`);
    } catch (err) { }
  };

  const findMessages = async (chatId) => {
    setLoading(true);
    try {
      const { data } = await api.get(
        `/chats/${chatId}/messages?pageNumber=${messagesPage}`
      );
      setMessagesPage((prev) => prev + 1);
      setMessagesPageInfo(data);
      setMessages((prev) => [...data.records, ...prev]);
    } catch (err) { }
    setLoading(false);
  };

  const loadMoreMessages = async () => {
    if (!loading) {
      findMessages(currentChat.id);
    }
  };

  const findChats = async () => {
    try {
      const { data } = await api.get("/chats");
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const renderGrid = () => {
    return (
      <Grid className={classes.gridContainer} container>
        <Grid className={classes.gridItem} md={4} item>
          {/* {user.profile === "admin" && ( */}
          <div className={classes.btnContainer}>
            <Button
              onClick={() => {
                setDialogType("new");
                setShowDialog(true);
              }}
              color="primary"
              variant="contained"
              className={classes.actionButton}
            >
              + Nova conversa
            </Button>
          </div>
          {/* )} */}
          <ChatList
            chats={chats}
            pageInfo={chatsPageInfo}
            loading={loading}
            handleSelectChat={(chat) => selectChat(chat)}
            handleDeleteChat={(chat) => deleteChat(chat)}
            handleEditChat={() => {
              setDialogType("edit");
              setShowDialog(true);
            }}
          />
        </Grid>
        <Grid className={classes.gridItem} md={8} item>
          {isObject(currentChat) && has(currentChat, "id") && (
            <ChatMessages
              chat={currentChat}
              scrollToBottomRef={scrollToBottomRef}
              pageInfo={messagesPageInfo}
              messages={messages}
              loading={loading}
              handleSendMessage={sendMessage}
              handleLoadMore={loadMoreMessages}
            />
          )}
        </Grid>
      </Grid>
    );
  };

  const renderTab = () => {
    return (
      <Grid className={classes.gridContainer} container>
        <Grid md={12} item>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, v) => setTab(v)}
            aria-label="disabled tabs example"
            className={classes.tabsRoot}
          >
            <Tab label="Chats" />
            <Tab label="Mensagens" />
          </Tabs>
        </Grid>
        {tab === 0 && (
          <Grid className={classes.gridItemTab} md={12} item>
            <div className={classes.btnContainer}>
              <Button
                onClick={() => setShowDialog(true)}
                color="primary"
                variant="contained"
                className={classes.actionButton}
              >
                Novo
              </Button>
            </div>
            <ChatList
              chats={chats}
              pageInfo={chatsPageInfo}
              loading={loading}
              handleSelectChat={(chat) => selectChat(chat)}
              handleDeleteChat={(chat) => deleteChat(chat)}
            />
          </Grid>
        )}
        {tab === 1 && (
          <Grid className={classes.gridItemTab} md={12} item>
            {isObject(currentChat) && has(currentChat, "id") && (
              <ChatMessages
                chat={currentChat}
                scrollToBottomRef={scrollToBottomRef}
                pageInfo={messagesPageInfo}
                messages={messages}
                loading={loading}
                handleSendMessage={sendMessage}
                handleLoadMore={loadMoreMessages}
              />
            )}
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <>
      <ChatModal
        type={dialogType}
        open={showDialog}
        chat={currentChat}
        handleLoadNewChat={(data) => {
          setMessages([]);
          setMessagesPage(1);
          setCurrentChat(data);
          setTab(1);
          history.push(`/chats/${data.uuid}`);
        }}
        handleClose={() => setShowDialog(false)}
      />
      <div className={classes.pageRoot}>
        <div className={classes.hero}>
          <div className={classes.heroBgCircle} />
          <div className={classes.heroLeft}>
            <div className={classes.heroIcon}>💬</div>
            <div>
              <Typography className={classes.heroTitle}>
                Chat Interno
              </Typography>
              <Typography className={classes.heroSubtitle}>
                Converse com a equipe em tempo real em um ambiente interno organizado
              </Typography>
            </div>
          </div>
          <div className={classes.heroRight}>
            <Chip
              label={chats.length + " conversas"}
              className={classes.heroChip}
              size="small"
            />
          </div>
        </div>

        <Paper className={classes.contentShell}>
          {isWidthUp("md", props.width) ? renderGrid() : renderTab()}
        </Paper>
      </div>
    </>
  );
}

export default withWidth()(Chat);
